import { UserDto } from "@/types/dto/user-dto";
import { atom } from "recoil";

export interface PartnerIncentiveModalState {
  user: UserDto;
  itemId: number;
  searchItemName: string;
  getPage: (name: string) => void;
}

export const isOpenPartnerIncentiveModal = atom<
  PartnerIncentiveModalState | undefined
>({
  key: "isOpenPartnerIncentiveModal",
  default: undefined,
});
